import Route from 'cio/routes/base';

export default class IndexRoute extends Route {
  redirect(model) {
    let baseRoute = model.isApiTriggered ? 'broadcasts.broadcast' : 'campaigns.campaign';
    let draftRoute = model.isApiTriggered ? 'recipients' : 'trigger';

    if (model.isDraft) {
      this.router.transitionTo(`${baseRoute}.setup.${draftRoute}`);
    } else {
      this.router.transitionTo(`${baseRoute}.setup.review`);
    }
  }
}
